var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 2.3H18.5V0H16.1667V2.3H6.83333V0H4.5V2.3H3.33333C2.03833 2.3 1.01167 3.335 1.01167 4.6L1 20.7C1 21.965 2.03833 23 3.33333 23H19.6667C20.95 23 22 21.965 22 20.7V4.6C22 3.335 20.95 2.3 19.6667 2.3ZM19.6667 20.7H3.33333V7H19.6667V20.7Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4945 8C8.4585 8 6 10.464 6 13.5C6 16.536 8.4585 19 11.4945 19C14.536 19 17 16.536 17 13.5C17 10.464 14.536 8 11.4945 8ZM11.5 17.9C9.069 17.9 7.1 15.931 7.1 13.5C7.1 11.069 9.069 9.1 11.5 9.1C13.931 9.1 15.9 11.069 15.9 13.5C15.9 15.931 13.931 17.9 11.5 17.9ZM11.775 10.75H10.95V14.05L13.8375 15.7825L14.25 15.106L11.775 13.6375V10.75Z",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4945 8C8.4585 8 6 10.464 6 13.5C6 16.536 8.4585 19 11.4945 19C14.536 19 17 16.536 17 13.5C17 10.464 14.536 8 11.4945 8ZM11.5 17.9C9.069 17.9 7.1 15.931 7.1 13.5C7.1 11.069 9.069 9.1 11.5 9.1C13.931 9.1 15.9 11.069 15.9 13.5C15.9 15.931 13.931 17.9 11.5 17.9ZM11.775 10.75H10.95V14.05L13.8375 15.7825L14.25 15.106L11.775 13.6375V10.75Z",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeIcon);
export default __webpack_public_path__ + "static/media/date-time-icon.56c3d6008a55e1f1e8234fb4eecc8383.svg";
export { ForwardRef as ReactComponent };